import { createIcon } from '@chakra-ui/react';

export const PayoutOutlineIcon = createIcon({
  displayName: 'PayoutOutlineIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
      <path
        d="M4.93337 4.21344L10.5934 2.32677C13.1334 1.4801 14.5134 2.86677 13.6734 5.40677L11.7867 11.0668C10.52 14.8734 8.44004 14.8734 7.17337 11.0668L6.61337 9.38677L4.93337 8.82677C1.1267 7.5601 1.1267 5.48677 4.93337 4.21344Z"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.73999 9.09646L9.12666 6.70312"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});
